import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import LoadingOverlay from "react-loading-overlay-ts";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
import { read, utils } from "xlsx";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const gvcolumn = [
  {
    field: "ten_cosodaotao",
    headerName: "Tên cơ sở",
    width: 280,
    headerAlign: "center",
  },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "serial",
    headerName: "Serial",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ma_imei",
    headerName: "Mã IMEI",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "nhanhieu",
    headerName: "Nhãn hiệu",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "kieuloai",
    headerName: "Kiểu loại",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "loaiphuongtien",
    headerName: "Loại phương tiện",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "hopdong",
    headerName: "Hợp đồng",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "sogiayphep",
    headerName: "Số giấy phép",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "ngaycap_gpxtl",
    headerName: "Ngày cấp GPXTL",
    width: 170,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ngayhethan_gpxtl",
    headerName: "Ngày hết hạn GPXTL",
    width: 180,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ghichu",
    headerName: "Ghi chú",
    width: 180,
    headerAlign: "center",
  },
];
export default function Importxetaplai() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(100);
  const [cosodaotao, setCosodaotao] = React.useState([]);
  const [cosodaotao_id, setCosodaotao_id] = React.useState(null);
  const [xetaplai_id, setXetaplai_id] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [dataimport, setDataimport] = React.useState([]);
  const [selectedFiles, setSelectedFiles] = React.useState(undefined);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [disableBT1, setDisableBT1] = React.useState(true);
  const [openxoa, setOpenxoa] = React.useState(false);
  const [isActive, setActive] = React.useState(false);
  const handleClosexoa = () => {
    setOpenxoa(false);
    getxetaplai();
  };
  const huydulieu = () => {
    setOpenxoa(false);
    //setDisableBT(true);
  };
  const handleButtonClicked = () => {
    setActive(true);
  };
  const handleButtonDone = () => {
    setActive(false);
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const excelDateToJSDate = (serial) => {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    return (
      date_info.getFullYear() +
      "-" +
      (date_info.getMonth() + 1) +
      "-" +
      date_info.getDate()
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getcosodaotao = () => {
    var url =
      Config.backend +
      "/api/donvi/getdonviquanlytheouser?dmloaidonvi_id=" +
      6 +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCosodaotao(data);
        setCosodaotao_id({
          id: data[0].id,
          ten: data[0].ten,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  const getxetaplai = () => {
    if (cosodaotao_id.id > 0) {
      var url =
        Config.backend +
        "/api/Phuongtien/getxetaplaicsdt?cosodaotao_id=" +
        cosodaotao_id.id +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          setData(data);
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  const xoaxetaplai = () => {
    var url = Config.backend + "/api/Phuongtien/xoaxetaplai";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        xetaplai_id: xetaplai_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          getxetaplai();
          showNotification2();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const tieptucimport = () => {
    dataimport.map((item, i) => {
      if (i > 1 && item["STT"]) {
        insertdata(
          item["Số đăng ký xe"] ? item["Số đăng ký xe"] : "",
          item["Số serial"] ? item["Số serial"] : "",
          item["Mã IMEI"] ? item["Mã IMEI"] : "",
          item["Nhãn hiệu"] ? item["Nhãn hiệu"] : "",
          item["Kiểu loại"] ? item["Kiểu loại"] : "",
          item["Loại xe tập lái"] ? item["Loại xe tập lái"] : "",
          item["Hợp đồng"] ? item["Hợp đồng"] : "",
          item["Số giấy phép"] ? item["Số giấy phép"] : "",
          excelDateToJSDate(item["Ngày cấp"]),
          excelDateToJSDate(item["Ngày hết hạn"]),
          item["Ghi chú"] ? item["Ghi chú"] : "",
          cosodaotao_id.id,
          username
        );
      }
    });
    handleClosexoa();
    showNotification();
  };
  const insertdata = (
    sodangky,
    serial,
    ma_imei,
    nhanhieu,
    kieuloai,
    loaiphuongtien,
    hopdong,
    sogiayphep,
    ngaycap_gpxtl,
    ngayhethan_gpxtl,
    ghichu,
    cosodaotao_id,
    username
  ) => {
    var url = Config.backend + "/api/Phuongtien/themxetaplaicsdt";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        sodangky: sodangky,
        serial: serial,
        ma_imei: ma_imei,
        nhanhieu: nhanhieu,
        kieuloai: kieuloai,
        loaiphuongtien: loaiphuongtien,
        hopdong: hopdong,
        sogiayphep: sogiayphep,
        ngaycap_gpxtl: ngaycap_gpxtl,
        ngayhethan_gpxtl: ngayhethan_gpxtl,
        ghichu: ghichu,
        cosodaotao_id: cosodaotao_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          console.log(data);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
  };
  const uploadFiles = () => {
    if (cosodaotao_id.id > 0) {
      if (selectedFiles.length) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          const wb = read(event.target.result);
          const sheets = wb.SheetNames;
          if (sheets.length) {
            const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
            if (rows.length) {
              setDataimport(rows);
            }
          }
        };
        reader.readAsArrayBuffer(file);
      }
      setOpenxoa(true);
    } else {
      showNotification1();
    }
  };
  const getfile = () => {
    handleButtonClicked();
    window.location.href = Config.link + "04fdf52c-80f6-4177-af83-241cf1edf72f";
    /*window.open(
      "https://docs.google.com/viewer?url=" +
        Config.link +
        "52eb718e-90ee-4734-8e61-602293e8da28"
    );*/
    handleButtonDone();
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 2000);
  };
  React.useEffect(() => {
    getcosodaotao();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <FormControl style={{ width: "40%", marginTop: 3 }}>
          <Autocomplete
            freeSolo
            disableClearable
            size="small"
            options={cosodaotao}
            value={cosodaotao_id}
            getOptionLabel={(option) => option.ten}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              setCosodaotao_id(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Chọn cơ sở đào tạo"
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  style: {
                    height: "30px",
                    paddingTop: "initial",
                  },
                }}
              />
            )}
          />
        </FormControl>
        <FormControl style={{ width: "14%", marginLeft: 10, marginTop: 3 }}>
          <Button
            color="success"
            variant="contained"
            onClick={getxetaplai}
            style={{ height: 30 }}
          >
            Xem dữ liệu
          </Button>
        </FormControl>
        <FormControl style={{ width: "15%", marginLeft: 10, marginTop: 3 }}>
          <Button
            color="error"
            variant="contained"
            onClick={xoaxetaplai}
            style={{ height: 30 }}
            disabled={disableBT1}
          >
            Xóa xe tập lái
          </Button>
        </FormControl>
        <FormControl style={{ width: "13%", marginLeft: 10, marginTop: 3 }}>
          <Button
            color="warning"
            variant="contained"
            onClick={getfile}
            style={{ height: 30 }}
          >
            Tải file mẫu
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ height: "12vh" }}>
        <FormControl
          style={{ width: "100%", marginTop: "7px", height: "100%" }}
        >
          <div className="row my-3">
            <div className="col-8">
              <label className="btn btn-default p-0">
                <input
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={selectFiles}
                />
              </label>
            </div>
            <div className="col-4" style={{ marginTop: 10 }}>
              <FormControl style={{ width: "10%" }}>
                <Button
                  color="error"
                  variant="contained"
                  disabled={!selectedFiles}
                  onClick={uploadFiles}
                  style={{ height: "25px" }}
                >
                  Upload
                </Button>
              </FormControl>
            </div>
          </div>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <LoadingOverlay active={isActive} spinner={true} text="Vui lòng đợi...">
          <div style={{ height: 450, width: "100%" }}>
            <DataGrid
              getRowId={(row) => row.stt}
              rows={data}
              columns={gvcolumn}
              checkboxSelection={false}
              getRowHeight={() => "auto"}
              headerHeight={35}
              sx={datagridSx}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[20, 50, 100]}
              pagination
              initialState={{
                filter: {
                  filterModel: {
                    items: [],
                    quickFilterLogicOperator: GridLinkOperator.Or,
                  },
                },
              }}
              components={{ Toolbar: quickSearchToolbar }}
              onRowClick={(params) => {
                setDisableBT1(false);
                setXetaplai_id(params.row.xetaplai_id);
              }}
            />
          </div>
        </LoadingOverlay>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openxoa}
          onClose={handleClosexoa}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={8}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Xác nhận dữ liệu
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosexoa} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginLeft: 10 }}>
                        Import dữ liệu mới sẽ chỉ thêm xe tập lái chưa có trong
                        danh sách trước đây (không trùng số đăng ký)!
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        style={{ width: "20%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="success"
                          variant="contained"
                          onClick={tieptucimport}
                          style={{ height: 30 }}
                        >
                          Tiếp tục
                        </Button>
                      </FormControl>
                      <FormControl
                        style={{ width: "10%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="warning"
                          variant="contained"
                          onClick={huydulieu}
                          style={{ height: 30 }}
                        >
                          Hủy
                        </Button>
                      </FormControl>
                    </GridItem>
                  </CardBody>
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Import thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Vui lòng chọn cơ sở đào tạo"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
